import '../css/PP.css'

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>Last Updated: June 2026</p>
      </div>

      <div className="privacy-content">
        <p>
          At <strong>Amplemind</strong>, we respect your privacy and
          are committed to protecting your personal information. This Privacy
          Policy explains how we collect, use, and safeguard your data.
        </p>

        <section>
          <h2>1. Information We Collect</h2>
          <ul>
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Phone Number</li>
            <li>Educational Details</li>
            <li>Course Preferences</li>
            <li>IP Address and Browser Information</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To process admissions and registrations.</li>
            <li>To respond to inquiries and support requests.</li>
            <li>To provide course updates and notifications.</li>
            <li>To improve website functionality and user experience.</li>
          </ul>
        </section>

        <section>
          <h2>3. Cookies</h2>
          <p>
            Our website may use cookies to improve your browsing experience and
            analyze website traffic. You can disable cookies through your
            browser settings.
          </p>
        </section>

        <section>
          <h2>4. Information Sharing</h2>
          <p>
            We do not sell, rent, or trade your personal information. Data may
            only be shared when required by law or with trusted service
            providers assisting in website operations.
          </p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal
            information from unauthorized access, disclosure, or misuse.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Links</h2>
          <p>
            Our website may contain links to external websites. We are not
            responsible for the privacy practices of those websites.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <ul>
            <li>Request access to your information.</li>
            <li>Request corrections to inaccurate information.</li>
            <li>Request deletion of your personal data.</li>
            <li>Withdraw consent for communications.</li>
          </ul>
        </section>

        <section>
          <h2>8. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be
            posted on this page with an updated revision date.
          </p>
        </section>

        <section>
          <h2>9. Contact Us</h2>
          <p>Email: contact@amplemind.in</p>
          <p>Phone: +91 9552211561</p>
          <p>Address: 08, Near Zudio, Gurudev Nagar, Nagpur</p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;